import { publicPath } from "shared/helpers/publicPath";
import { KrPano } from "krpano";
import { useEffect, useState } from "react";
import { MAPBOX_TOKEN } from "config";

const KRPANO_CONTAINER = "krpano_container";

type UseEmbedPano = () => boolean;

/**
 * Embedd the krpano viewer in the DOM
 *
 * Optionally can be run here or in the `index.html` file
 * SEE: KRPANO-LOAD
 *
 * @returns `krpanoLoaded` - `true` if krpano is loaded
 */
export const useEmbedPano: UseEmbedPano = () => {
  const [krpanoLoaded, setKrpanoLoaded] = useState<boolean>(false);

  // Used when krpano is loaded with React
  useEffect(() => {
    window.embedpano({
      swf: publicPath("krpano/krpano.swf"),
      xml: publicPath("krpano/krpano.xml"),
      target: KRPANO_CONTAINER,
      html5: "auto",
      mobilescale: 1.0,
      passQueryParameters: "currentfield",
      // Always log to console (we remove debugs lower down)
      consolelog: true,
      onready: function (krpanointerface: KrPano) {
        console.debug("krpano onready fired");
        //
        // NOTE: <krpano onstart="init_interface()"`> Now appears to fire after `onready` is complete
        // To combat this the `init_interface` action now has `autorun="onstart"`
        //
        // Make `krpano` available globally
        window.krpano = krpanointerface;
        // Remove Debug Messages when not in production
        var debugMode = process.env.NODE_ENV !== "production";
        window.krpano.debugmode = debugMode;
        window.krpano.showerrors = false;
        window.krpano.debugjsactions = debugMode;
        window.krpano.debugjsplugins = debugMode;
        // Fullscreen control setup
        window.krpano.display.customFullscreenElement = document.body;
        // Additional global krpano variables - START
        window.krpano.global.mapbox_token = MAPBOX_TOKEN;
        // Additional global krpano variables - END
        // Loaded
        setKrpanoLoaded(true);
        //
      },
    });
    return () => {
      // https://krpano.com/docu/embedpano/#removing
      window.removepano(KRPANO_CONTAINER);
      // window.krpano.unload();
    };
  }, []);

  // Used when krpano is loaded by `index.html`
  // useEffect(() => {
  //   const readyListener = () => {
  //     console.debug("krpano__loaded event triggered");
  //     // NOTE: Deliberate delay
  //     // There is some issue with krpano not being ready and so no scenes are actually added.
  //     setTimeout(() => {
  //       setKrpanoLoaded(true);
  //     }, 100);
  //   };
  //   window.addEventListener("krpano__loaded", readyListener);
  //   // Clean up
  //   return () => {
  //     window.removeEventListener("krpano__loaded", readyListener);
  //   };
  // }, []);

  return krpanoLoaded;
};
